<template>
	<svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M45 30L22.5 46.4545L22.5 13.5455L45 30Z" fill="white" />
	</svg>
</template>
